<div class="page-content">
  <div class="header-container">
    <div class="header-content">
      <img
        class="logo"
        src="/assets/img/medtronic-academy.svg"
        alt="Medtronic Academy"
        width="248"
        height="17"
      />

    </div>
  </div>
  <div class="content">
    <div class="access-denied-message">
      <h2 class="error-message">
        {{ 'accessdenied' | translate }}
      </h2>
      <h3 class="error-details">
        {{ message || 'youdonothaveadministrationpermissions' | translate }}
      </h3>
    </div>
  </div>
  <div class="footer">
  </div>
</div>
